import { ComponentSectionsTagCloud } from '../graphql/generated/graphql';

export const tagCloud: ComponentSectionsTagCloud = {
  id: '1',
};
